import { Icon } from 'summon-ui'
import { useTranslation } from 'summon-ui/intl'
import { Button } from 'summon-ui/mantine'
import { useAccount } from 'wagmi'
import useLogin from '@hooks/useLogin'
import { useWeb3Modal } from '@web3modal/wagmi/react'

type ConnectButtonProps = {
  isMinimal?: boolean
}
const ConnectButton = ({ isMinimal = false }: ConnectButtonProps) => {
  const t = useTranslation()
  const { isConnecting, login } = useLogin()
  const { isConnected } = useAccount()
  const { open: openConnectModal } = useWeb3Modal()

  return (
    <Button
      p={0}
      data-testid='connect-wallet-button'
      fullWidth={!isMinimal}
      w={isMinimal ? 48 : '100%'}
      onClick={() => (isConnected ? login() : openConnectModal())}
      loading={isConnecting}
    >
      {isMinimal ? <Icon name='LogIn02' color='inherit' /> : t('LOGIN / SIGN UP')}
    </Button>
  )
}

export default ConnectButton
